import React from 'react';
import { Result } from 'antd';

/**
 * @description Error Component to show error page according to status codes
 */
export const ErrorPage = ({ status, message }) => {
  return (
    <div className="w-full h-full items-center">
      <Result
        title={status}
        subTitle={message}
        extra={
          <a className="ant-btn ant-btn-primary" href="/">
            Home
          </a>
        }
      />
    </div>
  );
};

export default ErrorPage;
